module.exports = __webpack_public_path__ + "media/video.27f3dc15.webm";